import '../plugins/FlexmasonryPlugin.js';
import '../plugins/ImageLoadedPlugin.js';

// filters init
export default function initFlexMasonry() {
	FlexMasonry.init('.js-flexmasonry-filter-grid', {
		responsive: true,
		breakpointCols: {
			'min-width: 1024px': 3,
			'min-width: 480px': 2,
			'min-width: 320px': 1,
		},
	});
}
